import Vue from 'vue'
import Router from 'vue-router'
import MarkdownEdit from './views/MarkdownEdit.vue'
import MarkdownList from './views/MarkdownList.vue'
import PersonalHome from './views/PersonalHome.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/md',
      name: 'MarkdownList',
      component: MarkdownList,
    },
    {
      path: '/md/_new',
      component: MarkdownEdit,
    },
    {
      path: '/md/:document_id',
      component: MarkdownEdit,
      props: true,
    },
    
    {
      path: '/ps',
      name: 'PersonalHome',
      component: PersonalHome,
    },
  ]
})
